export const getDriverCategoryList = (filters = {}, pageRequest = {}) => {
  return new Promise((res) => {
    res({
      driverCategories: [
        { id: 1, category: "Delivery", name: "Zomato" },
        { id: 2, category: "BlinkitDelivery", name: "Blinkit" },
        { id: 3, category: "InstantFoodDelivery", name: "Instant" },
      ],
    });
  });
};
